module.exports = __webpack_public_path__ + "static/img/3387_phase_function_Paper_Points.71c9a2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3387_phase_function_Paper_Points.png
// module id = gy55
// module chunks = 0